import { Panel, Radio, Title } from "dash-styled"
import React, { FC } from "react"

interface OnboardingOrgChooserPanelProps {
    name: string
    isSelected: boolean
    onChange: () => void
}

export const OnboardingOrgChooserPanel: FC<OnboardingOrgChooserPanelProps> = ({
    name,
    isSelected,
    onChange
}) => {
    return (
        <Panel
            size="sm"
            className="mb-3"
            noPadding={true}
            borderColor={isSelected ? "pink" : undefined}
        >
            <Radio
                className="p-4 w-full"
                color="violet"
                isChecked={isSelected}
                onChange={onChange}
            >
                <Title component="h3" variant="heading4" noMargin={true}>
                    {name}
                </Title>
            </Radio>
        </Panel>
    )
}
